import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuFormCategoryAppResource from "./LuFormCategoryAppResource";

class FormsetStartPageAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'formset-start-page';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'formset/start/pages';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'formCategoryId',
      'name',
      'headline',
      'description',
      'buttonLabel',
      'meta',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      formCategory: LuFormCategoryAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      formCategory: 'form_category_id',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      formCategoryId: {
        numericality: true,
        presence: true,
      },
      name: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      headline: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        presence: true,
        length: {
          maximum: 65535,
        },
      },
      buttonLabel: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      'meta.notifications': {
        arrayOfObjects: {
          value: {
            length: {
              maximum: 255,
            },
          },
        },
      },
    };
  }
}

export default FormsetStartPageAppResource;
